import React from "react";
import {atom} from "jotai";
import {InitializeProps, InitializeUrlProps} from "../types/initialize";
import ReactPlayer from "react-player";
import { CaptionListProps } from "../types/caption";

const params = new URLSearchParams(location.search);
let getParamsJobId = params.get("job_id");

//http://211.110.178.253:4000/api/vcast/translate/getTransData?job_id=TLI67988101
//http://211.110.178.253:4000/api/vcast/translate/getCaptionData?job_id=TLI67988101
//http://211.110.178.253:4000/api/vcast/translate/getSupportedTransData
//http://211.110.178.253:4000/api/vcast/translate/setTranslateJob?job_id=TLI67988101&srt_url=
//http://211.110.178.253:4000/api/storage/upload/uploadCaptionData


export const currentActivatedSegmentAtom = atom<CaptionListProps | null>(null)
export const captionSelectionModeState = atom<boolean>(false)

export const initializeUrlState = atom<InitializeUrlProps>({
    initialTransUrl: `${process.env.REACT_APP_VCAST_HOST}/api/vcast/translate/getTransData?job_id=${getParamsJobId}`,
    initialCaptionUrl: `${process.env.REACT_APP_VCAST_HOST}/api/vcast/translate/getCaptionData?job_id=${getParamsJobId}`,
    initialCaptionReferenceUrl: `${process.env.REACT_APP_VCAST_HOST}/api/vcast/translate/getCaptionReferenceData?job_id=${getParamsJobId}`,
    SupportedTransDataUrl: `${process.env.REACT_APP_VCAST_HOST}/api/vcast/translate/getSupportedTransData`,
    uploadCaptionUrl : `${process.env.REACT_APP_VCAST_HOST}/api/storage/upload/uploadCaptionData`,
    setCaptionUrl : `${process.env.REACT_APP_VCAST_HOST}/api/vcast/translate/setTranslateJob?job_id=${getParamsJobId}`,
    defaultCaptionUrl : `https://aitrans.vcastme.com/data/defaultsrt.json`,
    captionHistoryUrl : `${process.env.REACT_APP_VCAST_HOST}/api/storage/load/loadCaptionData/`,
    captionArchiveUrl : `${process.env.REACT_APP_VCAST_HOST}/api/vcast/translate/getCaptionArchiveData?archive_path=`,
    captionReferenceArchiveUrl : `${process.env.REACT_APP_VCAST_HOST}/api/vcast/translate/getCaptionReferenceArchiveData?archive_reference_path=`
});


export const reactPlayerAtom = atom<React.RefObject<ReactPlayer> | null >(null)

export const initializeState = atom<InitializeProps>({
  job_id: "",
  user_id: "",
  video_url: "",
  start_time: "00:00:00",
  end_time: "00:00:00",
  duration: 100,
  srt_url: "",
  srt_reference_url:"",
  video_title: "",
  video_language: "",
  text_limit: 40,
  // caption_max_time : 10,
  caption_max_time : 1000,
  // caption_min_time : 2,
  caption_min_time : 0.0002,
  supported_trans_service: [{
    trans_srt_id: "",
    trans_port: "",
    trans_path: "",
    trans_service: "",
    trans_url: ""
  }]
});


